import { ContractPerimeterType } from 'store/state'

const hasAccessToManageServices = (
  isInternal: boolean,
  contractPerimeter: ContractPerimeterType
): boolean => {
  const ACCESS_SERVICES = Boolean(
    parseInt(process?.env?.REACT_APP_ACCESS_SERVICES || '1', 10)
  )

  return !!(
    !isInternal &&
    ACCESS_SERVICES &&
    contractPerimeter.allItems &&
    contractPerimeter.allItems.length > 1
  )
}

export default hasAccessToManageServices
